module.exports = __webpack_public_path__ + "img/fr_success_6.9607a373.png";